package uz.ferro.erp.feature.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class EmailAuthBody(
    var email: String?
)